module.exports = __webpack_public_path__ + "img/协会网上办事系统.de5118b2.png";